import { Typography } from "@mui/material";

import Svg from "../../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../../ui library/HNSColors";
import STRINGS from "../../utils/strings";

export default function MetricInfo({ item }) {
  const colorsList = STRINGS.colors;
  const arrowsList = STRINGS.arrows;
  const color = item.colorState;
  const arrow = item.arrowState;

  return (
    <div
      className={`flex flex-row items-center justify-center gap-2 rounded-md border px-[26px] py-[14px] shadow-md`}
      style={{
        backgroundColor: colorsList[color].backgroundColor,
        borderColor: colorsList[color].borderColor,
      }}
    >
      <div className="flex flex-row items-center gap-2">
        <Typography
          className={`pl-4 text-base`}
          style={{
            color: HNSColors.neutrals[100],
          }}
        >
          {`${item.header}:`}
        </Typography>
        <Typography
          className="text-[22px] font-thin"
          style={{
            color: colorsList[color].arrowTextColor,
          }}
        >
          {`${item.value}`}
        </Typography>
        <div className="flex flex-col items-center justify-center">
          {arrowsList[arrow] && (
            <Svg
              name={arrowsList[arrow]}
              color={colorsList[color].arrowTextColor}
              sx={{
                height: "auto",
                width: "24px",
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
